import React from 'react'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import GitHubIcon from '@material-ui/icons/GitHub'
import TwitterIcon from '@material-ui/icons/Twitter'

export default function Banner(){
    const message = ["Who Is George Githiri Njihia?"]
    let i = 0
    let HeadArray = []
    for(i=0; i<message.length ; i++){
        HeadArray.push(
            <div className='col-lg-6 col-sm-9 mx-auto text-center banner'>
                <h3 className='typewriter'>
                    {message[i]}
                </h3>
            <p className='lead'>FullStack Software Engineer <span style={{color:"white"}}>|</span>Junior Data Analyst and Machine Learning Specialist <span style={{color:"white"}}>|</span> Mathematician</p>  
            <div className="d-flex col-7 mx-auto my-5 justify-content-center justify-content-between">
                        <a href="https://twitter.com/GithiriGeorge?s=09" target="_blank" style={{color:"var(--sectionColor)"}}><span><TwitterIcon className="mx-1"/>Twitter</span></a>
                        <a href= "https://www.linkedin.com/in/george-githiri-790873188" target="_blank" style={{color:"var(--sectionColor)"}}><span className="mx-1"><LinkedInIcon className="mx-1"/>LinkedIn</span></a>
                        <a href= "https://github.com/GeorgeGithiri5" target="_blank" style={{color:"var(--sectionColor)"}}><span><GitHubIcon className="mx-1"/>Github</span></a>
            </div>
            </div>
        )
    }
    return HeadArray
}